import {Fancybox} from '@fancyapps/ui/dist/fancybox'
import {handleProductFancy} from '@/app/js/fancy/product-fancy'
import {handleInsuranceFancy} from '@/app/js/fancy/insurance-fancy'
import {setFancyboxSettings} from '@/app/js/fancy/fancybox-settings'
import {handleAutoCreditingFancy} from '@/app/js/fancy/auto-crediting-fancy'
import {handleButtonsWithSource} from '@/app/js/fancy/button-with-source'
import {handleBannerWorkPopup} from '@/app/js/fancy/banner-work-popup'

export function initFancy() {
  setFancyboxSettings()

  handleProductFancy()
  handleInsuranceFancy()
  handleAutoCreditingFancy()
  handleButtonsWithSource()
  handleBannerWorkPopup()

  Fancybox.bind('[data-fancybox]')
}
